import { useMutation } from 'react-query';

import { setViewSettings as mutationFn } from 'api/endPoints/setViewSettings';

export const useMutationSetViewSettings = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    viewId: number;
    viewControls: {
        showBaseline: boolean;
        showlabels: boolean;
        colorBy: string;
    };
}
